// extracted by mini-css-extract-plugin
export default {"container":"style_container__uVFDh","title":"style_title__y4xS5","dropdownHolder":"style_dropdownHolder__-u+WV","label":"style_label__Yvfvp","select":"style_select__isYbF"};